import { useAppSelector } from '@/hooks/useAppSelector';

import { selectHasSecrets } from '../../services/selectors';
import { SecretsList } from '../SecretsList';
import { SecretsListContainer } from '../SecretsListContainer';
import { SecretsListEmpty } from '../SecretsListEmpty';

export interface SecretsProps {
    paddingTop?: number;
}

export const Secrets = ({ paddingTop }: SecretsProps) => {
    const hasSecrets = useAppSelector(selectHasSecrets);

    return (
        <SecretsListContainer isEmpty={!hasSecrets} empty={<SecretsListEmpty />}>
            {({ height, width }) => <SecretsList height={height ?? 600} width={width ?? 800} paddingTop={paddingTop} />}
        </SecretsListContainer>
    );
};
